import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {DataService} from '../../core/data.service';
import {ClrDatagridStateInterface} from '@clr/angular';
import {HIUser} from '../../core/HIUser';
import {Observable} from 'rxjs';
import {Page} from '../../core/Page';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {Pet} from '../pets/pet';
import {CdkDragDrop, DragRef, DropListRef, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import {Booking} from '../../core/Booking';
import {formatDate} from '@angular/common';
import {ActivatedRoute, Router} from '@angular/router';
import {Kennel} from 'src/app/core/Kennel';
import {ImageUploadService} from '../image-upload/image-upload.service';
import {PenBooking} from '../pets/PenBooking';
import {StepInfo, StepMode} from '../step/step.component';
import {LanguageStep} from '../step/language-pack.interface';
import {AlertService} from '../../alert.service';
import {BookingStepMode} from './BookingStepMode';
import {RestStateInterface} from '../../core/RestStateInterface';
import {CustomAuthService} from '../../auth.service';
import {PetNote} from '../pet-detail/PetNote';
import {promise} from 'selenium-webdriver';
import {reject} from 'q';

@Component({
  selector: 'booking-stepper',
  templateUrl: './booking-stepper.component.html',
  styleUrls: ['./booking-stepper.component.scss']
})
export class BookingStepperComponent implements OnInit {

  @Input() // Called from Customer control panel
  set user(user: number) {
      this.mode = BookingStepMode.SELF_NEW_BOOKING;
    this.isReservation = true;
    this.customerSid = user;
    this.dataService.callGet('user/summaryWithPets/' + user)
    .subscribe(
        (u) => {
          this.populateKennels();
          this.populateCustomer(u);
          this.stepInfo[0].mode = StepMode.CLOSED;
          this.stepInfo[1].mode = StepMode.OPEN;
        },
        (error) => console.log(error));
  }
  @Input() // Always called from Admin navigation
  set kennel(kennel: number) {
      this.selectedKennel = kennel;
      this.mode = this.mode ? this.mode : BookingStepMode.ADMIN_NEW_BOOKING;
  }
  mode: BookingStepMode;

  stepInfo: StepInfo[];
  // When a Customer makes a reservation request set to true
  isReservation = false;
  // Upgrade from Reservation Request to Booking by kennel administrator
  reservationNumber: number;
  customerSid: number;

  private searchControl: FormControl;
  private debounce = 400;
  selectedCustomer: HIUser;
  selectedKennel: number;
  selectedKennelName = null;
  kennels: Kennel[] = [];
  kennels$: Observable<Page<Kennel>>;
  users: HIUser[] = [];
  users$: Observable<Page<HIUser>>;
  bookingError = '';
  validBooking = false;
  petsInBooking = '';

  pets$: Observable<Page<Pet>>;


  // TODO When this goes in add restictions: https://github.com/vmware/clarity/issues/1984
  dateIn: any;
  dateOut: any;
  addUser = false;
  addPet = false;
  totalCost: any;
  originalTotalCost: number;
  bookingSid: number;
  kennelSelect: number;
  remainingPets: Pet[] = [];
  penBookings: PenBooking[] = [new PenBooking()];

  numDogPens = 0;
  numCatPens = 0;
  toDateError = '';

  selectedPet: Pet = new Pet('blank');


    constructor(private dataService: DataService,
                private cdr: ChangeDetectorRef,
                private route: ActivatedRoute,
                private router: Router,
                private imageUploadService: ImageUploadService,
                public authService: CustomAuthService,
                private alertService: AlertService) {
        this.selectedCustomer = new HIUser();
        this.checkBookingDataSent();
    }
    checkBookingDataSent() {
        const bookingData = this.authService.getBookingData();
        if (bookingData) {
            console.log('bookingData', bookingData)
            this.dateIn = bookingData.dateIn;
            this.dateOut = bookingData.dateOut;
            this.kennelSelect = bookingData.selectedKennel.sid;
            this.selectedKennel = bookingData.selectedKennel.sid;
            this.selectedKennelName = bookingData.selectedKennel.name;
            this.numDogPens = bookingData.numDogPens;
            this.numCatPens = bookingData.numCatPens;
            this.authService.updateBookingData(null);
        }
    }

    async selectedPetsFromHome() {
        const dogs = this.numDogPens;
        const cats = this.numCatPens;
        const dogsRem = this.remainingPets.filter(obj => obj.type === 'DOG');
        const catsRem = this.remainingPets.filter(obj => obj.type === 'CAT');
        let checkDogs = 0;
        let checkCats = 0;
        if (checkDogs < dogs) {
            const loopCount = dogs - dogsRem.length;
            for (let i = 0; i < loopCount; i++) {
                await this.addPetIfLess('DOG', 'DOG');
                checkDogs = checkDogs + 1;
            }
        }
        if (checkCats < cats) {
            const loopCount = cats - catsRem.length;
            for (let i = 0; i < loopCount; i++) {
                await this.addPetIfLess('CAT', 'CAT');
                checkCats = checkCats + 1;
            }
        }
        const removeIndexes = [];
        for (let i = 0; i < this.remainingPets.length; i++) {
            if (this.remainingPets[i].type === 'DOG' && checkDogs < dogs) {
                checkDogs = checkDogs + 1;
                if (this.penBookings.length === 0) {
                    this.penBookings.push(new PenBooking());
                }
                this.penBookings[this.penBookings.length - 1].pets.push(this.remainingPets[i]);
                removeIndexes.push(i);
            }
            if (this.remainingPets[i].type === 'CAT' && checkCats < cats) {
                checkCats = checkCats + 1;
                if (this.penBookings.length === 0) {
                    this.penBookings.push(new PenBooking());
                }
                this.penBookings[this.penBookings.length - 1].pets.push(this.remainingPets[i]);
                removeIndexes.push(i);
            }
        }
        if (removeIndexes.length > 0) {
            const newArray = [];
            for (let i = 0; i < this.remainingPets.length; i++) {
                if (!removeIndexes.includes(i)) {
                    newArray.push(this.remainingPets[i]);
                }
            }
            this.remainingPets = newArray;
        }
        this.calculatePetsInBooking();
    }

    addPetIfLess(name, type) {
        const newPetModel = new Pet(name, type);
        return new Promise((resolve, rejects) => {
            newPetModel.owner = this.selectedCustomer;
            this.dataService.callPostAndGet('pet', JSON.stringify(newPetModel)).subscribe(
                newPet => {
                    let pen = null;
                    this.penBookings.forEach(p => {
                        if (p.pets.length > 0 && p.pets[0].type === newPet.type) {
                            pen = p;
                        }
                    });
                    if (!pen) {
                        pen = this.penBookings[this.penBookings.length - 1];
                        this.penBookings.push(new PenBooking());
                    }
                    pen.pets.push(newPet);
                    resolve(true);
                },
                error => {
                    resolve(error);
                }
            );
        });
    }
    editSelected(step: number) {
        this.stepInfo.forEach((stepInfo, index) => {
            if (index !== step) {
                if (stepInfo.mode === StepMode.EDIT) {
                    stepInfo.mode = StepMode.COMPLETE;
                } else if (stepInfo.mode === StepMode.OPEN) {
                    stepInfo.mode = StepMode.CLOSED;
                }
            }
        });
    }
    nextStep(currentStep: number, nextStep: number) {
        if (this.toDateError === '') {
            const editing = this.stepInfo.findIndex(it => it.mode === StepMode.EDIT);
            if (editing !== -1) {
                this.stepInfo[editing].mode = StepMode.COMPLETE;
            } else {
                this.stepInfo[currentStep].mode = StepMode.COMPLETE;
            }
            this.stepInfo[nextStep].mode = StepMode.OPEN;
        }
    }

    setupSteps() {
        this.stepInfo = [
            this.newStep('Select Customer'),
            this.newStep('Select Pets'),
            this.newStep('Select Dates'),
            this.newStep('Select Kennel'),
            this.newStep('Confirmation')];
        this.stepInfo[1].text.continue = 'Continue to dates';
    }

    populateReservationOrBooking(reservationSid: number, isReservation: boolean) {
        if (isReservation) {
            this.reservationNumber = reservationSid;
        }
        const endpoint = isReservation ? 'reservation/' : 'bookings/';
        this.dataService.callGet(endpoint + reservationSid)
            .subscribe(
                (booking) => {
                    this.stepInfo[0].mode = StepMode.COMPLETE;
                    this.stepInfo[1].mode = StepMode.COMPLETE;
                    this.stepInfo[2].mode = StepMode.COMPLETE;
                    this.stepInfo[4].mode = StepMode.OPEN;
                    this.penBookings = booking.penBookings;
                    this.selectedKennel = booking.kennelSid;
                    this.populatePenBookings();
                    this.dateIn = new Date(booking.dateIn);
                    this.dateOut = new Date(booking.dateOut);
                    this.bookingSid = booking.sid;
                    this.originalTotalCost = booking.totalCost;

                    this.customerSid = booking.customerSid;
                    this.dataService.callGet('user/summaryWithPets/' + booking.customerSid)
                        .subscribe(
                            (u) => {
                                this.populateCustomer(u);
                                this.calculatePetsInBooking();
                                if (isReservation) {
                                    this.validateBooking();
                                }
                            },
                            (error) => console.log(error));
                },
                (error) => console.log(error));
    }

  ngOnInit() {
      this.setupSteps();
      this.stepInfo[0].mode = StepMode.OPEN;
      this.searchControl = new FormControl('');
      this.searchControl.valueChanges
          .pipe(debounceTime(this.debounce), distinctUntilChanged())
          .subscribe(query => {
              this.populateUsers(query);
          });
      this.cdr.detectChanges();
      if (this.route.snapshot.params['customer']) {
          this.mode = BookingStepMode.ADMIN_NEW_BOOKING_FOR_CUSTOMER;
          this.dataService.callGet('user/summaryWithPets/' + this.route.snapshot.params['customer'])
              .subscribe(
                  (user: HIUser) => {
                      this.populateCustomer(user);
                      this.stepInfo[0].text.description = this.buildName(user);
                      this.stepInfo[0].mode = StepMode.CLOSED;
                      this.stepInfo[1].mode = StepMode.OPEN;
                  },
                  (error) => console.log(error));
      }
      if (this.route.snapshot.params['bookingSid']) {
          this.mode = BookingStepMode.ADMIN_VIEW_BOOKING;
          this.populateReservationOrBooking(this.route.snapshot.params['bookingSid'], false);
      }
      if (this.route.snapshot.params['reservationSid']) {
          this.mode = BookingStepMode.ADMIN_VIEW_RESERVATION;
          this.populateReservationOrBooking(this.route.snapshot.params['reservationSid'], true);
      }
  }

    private buildName(user: HIUser) {
        return user.title + ' ' + user.firstName + ' ' + user.surname;
    }

    private newStep(label: string = 'label'): StepInfo {
      let text: LanguageStep;
      text = {label: label};
      return {
          text: text,
          mode: StepMode.CLOSED,
      };
  }
  validateBooking() {
    if (this.dateOut == null || this.dateIn == null) {
        this.validBooking = false;
        this.bookingError = 'Please select dates in and out';
        return;
    }
      const booking = this.makeBookingEntity();
      this.dataService.callPost('availability', JSON.stringify(booking)).subscribe(
          result => {
              this.validBooking = true;
              this.totalCost = result.body.totalPrice;
          },
          error => {
              this.validBooking = false;
              this.bookingError = error.error;
          }
      );
  }


  saveBooking() {
    const booking = this.makeBookingEntity();
    const bookingUrl = this.isReservation ? 'reservation' : 'bookings';
    this.dataService.callPost(bookingUrl, JSON.stringify(booking)).subscribe(
        () => {
          // TODO Alert service
          if (this.selectedKennel) {
            this.alertService.info('Booking saved for ' + this.buildName(this.selectedCustomer));
            this.router.navigate(['/admin']);
          } else {
            this.alertService.info('Your Booking Request has been saved');
            this.router.navigate(['/customer/tiles']);
          }
          this.authService.updateBookingData(null);
        },
        error => {
            this.alertService.warn('Failed to save booking with error: ' + error);
        }
    );
  }

  private makeBookingEntity() {
    const booking = new Booking();
    booking.sid = this.bookingSid;
    booking.reservationNumber = this.reservationNumber;
    booking.customerSid = this.customerSid ? this.customerSid : this.selectedCustomer.sid;
    booking.kennelSid   = this.selectedKennel ? this.selectedKennel : this.kennelSelect;
    this.penBookings.forEach(pen => {
      if (pen.pets.length > 0) {
        pen.petType = pen.pets[0].type;
        pen.petSids = pen.pets.map(p => p.sid);
        booking.penBookings.push(pen);
      }
    });
    booking.totalCost = this.originalTotalCost ? this.originalTotalCost : this.totalCost;
    if (this.dateIn) {
      booking.dateIn = formatDate(this.dateIn, 'yyyy-MM-dd HH:mm:ss', 'en-UK');
    }
    if (this.dateOut) {
      booking.dateOut = formatDate(this.dateOut, 'yyyy-MM-dd HH:mm:ss', 'en-UK');
    }
    return booking;
  }

  populateCustomer(customer: HIUser, reset: Boolean = false) {
    if (reset) {
      this.penBookings = [new PenBooking()];
      this.petsInBooking = '';
    }
    this.selectedCustomer = customer;
    if (customer.pets) {
      this.remainingPets = customer.pets;
      this.setPetPics(this.remainingPets);
    } else {
      this.pets$ = this.dataService.callGetPaged('pet/userId/' + customer.sid, null);
      this.pets$.subscribe(
      x => {
        this.remainingPets = x.content;
        this.setPetPics(this.remainingPets);
      },
      error => {
        console.log(error);
      }
      );
    }
  }
  setPetPics(petList: Pet[]) {
    this.selectedPetsFromHome();
    petList.forEach( pet => {
      if (pet.pic && !pet.pic.startsWith('asset')) {
        this.imageUploadService.fetchPetImage(pet.pic)
          .then(
            (img) => {
              this.remainingPets.find(it => it.sid === pet.sid).displayPic = 'data: image/png;base64,' + img;
           },
            (err) => console.log(err)
          );
      }
    });
    this.populatePenBookings();
  }
  populatePenBookings() {
    this.penBookings.forEach(pb => {
      if ((pb.pets && pb.pets.length > 0) || pb.petSids.length === 0) {
        return;
      }
      pb.pets = this.remainingPets.filter(p => pb.petSids.includes(p.sid));
      this.remainingPets = this.remainingPets.filter(p => !pb.petSids.includes(p.sid));
    });
  }

  populateUsers(query: string) {
    const state: RestStateInterface = {};
    state.filters = [];
    state.filters.push({'property': 'identifier', 'value': query});
    this.users$ = this.dataService.callGetPaged('user', state);
    this.users$.subscribe(
        x => {
          this.users = x.content;
        },
        error => {
          console.log(error);
        }
    );
  }

  populateKennels() {
    const state: RestStateInterface = {};
    state.filters = [];
    this.kennels$ = this.dataService.callGetPaged('kennel/search', state);
    this.kennels$.subscribe(
        x => {
          this.kennels = x.content;
          if (this.kennels.length === 1) {
            this.selectedKennel = this.kennels[0].sid;
          }
        },
        error => {
          console.log(error);
        }
    );
  }


  petTypePredicate = (drag: DragRef, drop: DropListRef) => {
    return drop.data.length === 0 || drop.data[0].type === drag.data.type;
  }



  drop(event: CdkDragDrop<Pet[]>) {
      if (event.previousContainer === event.container) {
          moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
      } else {
        transferArrayItem(event.previousContainer.data,
            event.container.data,
            event.previousIndex,
            event.currentIndex);
        let emptyPen = false;
        let needPen = false;
        if (this.remainingPets.length === 0) {
          emptyPen = false;
        } else {
          emptyPen = true;
        }
        const toRemove = [];
        let totalPets = 0;
        this.penBookings.forEach((value, i) => {
          const lastEntry = this.penBookings.length === i + 1;
          // If empty and not last entry remove
          // if empty and last entry and not add epty pen remove
          if (value.pets.length === 0 && (!lastEntry || (lastEntry && !emptyPen))) {
            toRemove.push(i);
          }
          totalPets += value.pets.length;
          // if not empty and last entry and add empty pen, add empty pen
          if (value.pets.length > 0 && lastEntry && emptyPen) {
            needPen = true;
          }
        });
        toRemove.reverse();
        toRemove.forEach((i) => {
          this.penBookings.splice(i, 1);
        });
        if (needPen) {
          this.penBookings.push(new PenBooking());
        }
        this.calculatePetsInBooking();
      }
  }
  calculatePetsInBooking() {
      this.petsInBooking = '';
      console.log(this.penBookings, 'pen')
      const dogPens = { pets: 0, length: 0 };
      const catPens = { pets: 0, length: 0 };
      this.penBookings.forEach(pen => {
          pen.pets.forEach((pet, index) => {
              if (pet.type === 'DOG') {
                  dogPens.pets = dogPens.pets + 1;
                  if (index === 0) {
                      dogPens.length = dogPens.length + 1;
                  }
              } else {
                  catPens.pets = catPens.pets + 1;
                  if (index === 0) {
                      catPens.length = catPens.length + 1;
                  }
              }
          });
      });
      this.petsInBooking += 'You are booking in ';
      if (dogPens.pets === 1 && catPens.pets === 0) {
          this.petsInBooking += dogPens.pets + ' dog';
      } else if (catPens.pets === 1 && dogPens.pets === 0) {
          this.petsInBooking += catPens.pets + ' cat';
      } else {
          if (dogPens.pets > 0) {
              this.petsInBooking += dogPens.pets;
              if (catPens.pets > 0) {
                  this.petsInBooking += ' dog(s) and ' + catPens.pets + ' cat(s)'
                      + ' you require, ' + dogPens.length + ' dog and ' + catPens.length + ' cat pens.';
              } else {
                  this.petsInBooking += ' dog(s) and require ' + dogPens.length + ' dog pen(s).';
              }
          } else if (catPens.pets > 0) {
              this.petsInBooking += catPens.pets;
              if (dogPens.pets > 0) {
                  this.petsInBooking += 'cat(s) and ' + dogPens.pets + ' dog(s)'  + ' you require, '
                      + dogPens.length + ' dog and ' + catPens.length + ' cat pens.';
              } else {
                  this.petsInBooking += ' cat(s) and require ' + catPens.length + ' cat pen(s).';
              }
          }
      }
  }

  handleModifiedUser($event: HIUser) {
    if (!$event || !$event.sid) {
      this.addUser = false;
      return;
    }
    this.selectedCustomer = $event;
          this.addUser = false;
          this.users = [];
          this.penBookings = [new PenBooking()];
          this.remainingPets = [];
      this.nextStep(0, 1);
  }
  handleSavedPet(newPetModel: Pet) {
    this.selectedPet = new Pet('blank');
    newPetModel.owner = this.selectedCustomer;
    this.dataService.callPostAndGet('pet', JSON.stringify(newPetModel)).subscribe(
      newPet => {
        let pen = null;
        this.penBookings.forEach(p => {
          if (p.pets.length > 0 && p.pets[0].type === newPet.type) {
            pen = p;
          }
        });
        if (!pen) {
          pen = this.penBookings[this.penBookings.length - 1];
          this.penBookings.push(new PenBooking());
        }
        pen.pets.push(newPet);
        this.addPet = false;
      },
      error => {
          console.log(error);
      }
    );
  }

    displayCustomerName() {
        return this.mode === BookingStepMode.ADMIN_NEW_BOOKING_FOR_CUSTOMER ||
               this.mode === BookingStepMode.ADMIN_VIEW_BOOKING ||
               this.mode === BookingStepMode.ADMIN_VIEW_RESERVATION;
    }

    onDateChange(goto = false) {
        if (this.dateIn && this.dateOut) {
            const fromDate = new Date(this.dateIn).getTime();
            const toDate = new Date(this.dateOut).getTime();
            if (toDate < fromDate) {
                this.toDateError = 'Please select To date greater than From date';
            } else {
                this.toDateError = '';
                if (goto) {
                    this.nextStep(2, 3);
                }
            }
        } else if (!this.dateIn && !this.dateOut) {
            this.toDateError = 'Please select dates first';
        }
    }
}
